<template>
  <div class="my-message"
       v-bind:class="{'is-select': IsSelected ,'fully': chat.Attachments.length > 0 }">
    <div class="inner">
      <div v-if="chat.SendStatus==2">
        <label>ارسال شده از {{chat.SourceSenderName}}</label>
        <hr>
      </div>
      <div v-if="chat.Attachments.length > 0">
        <div v-for="att in chat.Attachments">
          <div v-if='chat.Attachments.length == 1 && att.DocType==3'>
            <img :src="att.DocUrl" class="attachment-img" v-on:click="openImg(att.DocUrl)"/>
            <div class="text-center attach-name"
                 v-if="att.Caption != ' ' && att.Caption != '' && att.Caption != null">
              {{ att.Caption }}
            </div>
            <div class="text-center attach-name"
                 v-if="att.Caption == ' ' || att.Caption == '' || att.Caption == null">
              {{ att.Image_Name }}
            </div>
          </div>
          <span class="multi-attach" v-else>
                  <a @click="openLink(att.DocType ,att.DocUrl,att.Caption)" class="attachment-img" v-if="att.DocType==2" download>
                      <v-icon>
                          mdi-file
                      </v-icon>
                    </a>
                    <img :src="att.DocUrl" class="attachment-img" v-if="att.DocType==3"
                         v-on:click="openImg(att.DocUrl)"/>
                    <span :src="att.DocUrl" class="attachment-img" v-if="att.DocType==5"
                          v-on:click="openImg(att.DocUrl)">
                      <audio controls>
  <source :src="att.DocUrl" type="audio/ogg">
Your browser does not support the audio element.
</audio>
                      <v-icon>
                          mdi-file
                      </v-icon>
                    </span>
                     <span :src="att.DocUrl" class="attachment-img" v-if="att.DocType==6"
                           v-on:click="openImg(att.DocUrl)">
                      <v-icon>
                          mdi-file
                      </v-icon>
                    </span>
                     <div class="attachment-img" v-if="att.DocType==4"
                          v-on:click="openMap(att.DocUrl)">
                      <img src="/img/location_icon.svg"/>
                    </div>

                    <div class="text-center attach-name"
                         v-if="att.Caption != ' ' && att.Caption != '' && att.Caption != null">
                      {{ att.Caption }}
                    </div>
                    <div class="text-center attach-name"
                         v-if="att.Caption == ' ' || att.Caption == '' || att.Caption == null">
                      {{ att.Image_Name }}
                    </div>
                  </span>
        </div>
      </div>
      <div v-if="chat.SourceItem!=0 && chat.SendStatus==1" style="color: grey;font-size: 14px;">
        <label>{{chat.SourceText}}</label>
        <hr>
      </div>
<!--      <span class="text" :id="'chat_text_'+ index"-->
<!--            v-html="urlify(chat.MessageText)"-->
<!--            :value="chat.MessageText">-->

<!--               </span>-->
      <EmojiViewer :index="index" :data="chat.MessageText" />
<!--      <emoji-->
<!--        set="apple"-->
<!--        emoji="shrug"-->
<!--        :size="24"-->
<!--        :fallback="emojiFallback"-->
<!--      />-->
      <div class="deliver" :data-date="chat.SubmitDateTime">
                 <span>
                   <v-icon v-if="chat.status==10">
                     mdi-check-all
                   </v-icon>
                   <v-icon v-if="chat.status==5">
                     mdi-check
                   </v-icon>
                   <v-icon v-if="chat.status==1">
                     mdi-clock-outline
                   </v-icon>
                 </span>
        {{ get_conversation_date(chat) }}
      </div>
    </div>

  </div>

</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import { bus } from '../../../main.js'
import EmojiViewer from './EmojiViewer'
  // import VueContext from 'vue-context';
  // import 'vue-context/src/sass/vue-context.scss';
  // import TextareaEmojiPicker from '../../components/TextareaEmojiPicker.vue'
  import { Picker } from 'emoji-mart-vue'
  import { Emoji } from 'emoji-mart-vue'
  import Vue from 'vue'
  import InfiniteLoading from 'vue-infinite-loading'
import emojiData from 'emoji-mart-vue/data/messenger.json'
  export default {
    components: {
      InfiniteLoading,
      VueSlickCarousel,
      VuetifyAudio: () => import('vuetify-audio'),
      Emoji,
      Picker,
      EmojiViewer
    },

    data () {
      return {}
    },
    props: {
      chat: Object,
      RecTypeId: Number,
      index: Number,
      IsSelected: Boolean,
      date_now: String
    },
    beforeDestroy () {
      bus.$off('signalr_methods', this.listener)
    },
    mounted () {
      // this.configRecording()

      // window.addEventListener('resize', this.resize_mobile, {passive: true})
      // this.resize_mobile()
    },

    watch: {},

    methods: {
      emojiFallback (emoji) {
        console.log('emoji fallback is', emoji)
        return ':smile:'
      },
      get_conversation_date (item) {
        var date = item.SubmitDateTimeMiladi
        date = date.replace('  ', ' ')
        var days = 0
        var dateNow = new Date(this.convert_string_to_date(this.date_now))
        var conv_date = new Date(this.convert_string_to_date(date))
        // var conv_date_hour2 = new Date(item.SubmitDateTime)

        var reportDate = item.SubmitDateTime.substring(11)
        // console.log(item)
          days = dateNow - conv_date

        days = days / (1000 * 60 * 60 * 24)

        var ret
        if (days < 1) {
          ret = reportDate
        // }
        // else if (days >= 1 && days < 2) {
        //   ret = ' دیروز ' + reportDate
        // } else if ((days < 8) && (days > 1)) {
        //   ret = days + ' روز قبل ' + reportDate
        } else {
          ret = item.SubmitDateTime
        }

        return ret
      },
      convert_string_to_date (date) {
        var dateString = date

        var reggie = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/
        var dateArray = reggie.exec(dateString)

        // var date = dateArray[3]+"-"+dateArray[2]+"-"+dateArray[1]+"T00:00:00.000+03:30"
        try {
          var dateObject = new Date(
            (+dateArray[3]),
            (+dateArray[2]), // Careful, month starts at 0!
            (+dateArray[1]),
            (+dateArray[4]),
            (+dateArray[5]),
            (+dateArray[5])
          )
          return dateObject.toDateString()
        } catch (e) {
          return ''
        }
      },
      openLink (type, link, caption) {
        link = link.replace('http://chidl', 'https://chidl')
        if (type == 1) {
          console.log('link ', link)
          window.open(link, '_blank')
        }
        if (type == 6) {
          window.open(link, '_blank')
        }
        if (type == 2) {
          console.log("caption is",caption)
          window.open(link, caption)
          // var a = document.createElement("a");
          // a.href = link;
          // a.download = caption;
          // document.body.appendChild(a);
          // a.click();
          // document.body.removeChild(a);
          // if (caption != null && caption != '') {
          //   }else{
          //     window.open(link, '_blank')
          //
          //   }
          // var link_a = document.createElement('a')
          //   document.body.appendChild(link_a) // Firefox requires the link to be in the body
          //   if (caption != null && caption != '') {
          //     link_a.download = caption
          //   }
          //   link_a.href = link
          //   link_a.click()
          //   document.body.removeChild(link_a) // remove the link when done
        }
        if (type == 4) {
          link = link.split('*')
          link = 'https://www.google.com/maps/search/?api=1&query=' + link
          window.open(link, '_blank')
        }
      },
      openImg (item) {
        bus.$emit('open_image_chat', item)
        // this.dialog = true
        // this.open_image = item
        // console.log('open')
      },
      openMap (item) {
        window.open('https://www.google.com/maps?q=' + item.split('*')[0] + ',' + item.split('*')[1] + '&z=17&hl=en')
      },
      urlify (text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g
        return text.replace(urlRegex, function (url) {
          return '<a target="_blank" href="' + url + '">' + url + '</a>'
        })
        // or alternatively
        // return text.replace(urlRegex, '<a href="$1">$1</a>')
      },
    }
  }
</script>
<style lang="scss" scoped>
  .basemap {
    width: 100%;
    height: 500px;
  }
</style>
